export const WHY_ONEMIND_CONSTANTS = {
  title: "Network Digital Twin Cloud by OneMind Services",
  desc: [
    {
      text: "OneMind Services introduces the world's first Network Digital Twin Cloud, revolutionizing how businesses approach network management and innovation. Serving over 2,500 active customers worldwide, including Fortune 500 companies and the U.S. government, OneMind Services offers a robust platform for network-based Proof-of-Concepts (POCs), labs, and network automation.",
      highlight: [
        "OneMind Services",
        "Network Digital",
        " Twin Cloud",
        "network management",
        "Proof-of-Concepts (POCs)",
        "network automation",
      ],
    },
  ],
};
